import React from "react";
import Recommendations from "./Screens/Recommendations";
import MakeupDay from "./Screens/MakeupDay";
import CustomDate from "./Screens/CustomDate";
import RescheduleReview from "./Screens/RescheduleReview";
import Container from "./Components/Container";
import TitleSection from "./Components/TitleSection";
import NoAppointmentsImage from "../../assets/no_appointments.png";
import RescheduleWindowClosedImage from "../../assets/reschedule_window.png";
import AppointmentRemovedImage from "../../assets/appointment_removed.png";
import SomethingWentWrongImage from "../../assets/something_went_wrong.png";
import RescheduleCompleteImage from "../../assets/reschedule_complete.png";
import { GoHomePrimary, STEPS } from "./utils";
import CancelAppointment from "./Screens/CancelAppointment";
import EventSummary from "./Components/EventSummary";
import { LoadingScreen } from "components/EventScheduling/EventSchedulingUtils";
import { useRescheduling } from "./ReschedulingProvider";
import { Button } from "@mui/material";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function FlowManager() {
  const {
    currentStep,
    rescheduleOptionsLoading,
    callInfo,
    reschedulingError,
    isReschedulingError,
  } = useRescheduling();
  const is400Error = reschedulingError?.response?.status === 400;

  const isWithin24Hours =
    new Date(callInfo?.scheduled_date).getTime() - new Date().getTime() < 24 * 60 * 60 * 1000;
  const isWithinRescheduleWindow = !isWithin24Hours;
  // const hasAvailableAppointments = rescheduleOptions?.length > 0;
  const hasAvailableAppointments = true;

  if (rescheduleOptionsLoading) return <LoadingScreen />;

  // Appointment do not exist
  if (is400Error) {
    return (
      <Container>
        <TitleSection
          imageSrc={AppointmentRemovedImage}
          title="Your appointment has been removed."
          subtitle="Your appointment was removed from your calendar and is no longer available."
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowsClockwise />}
          onClick={() => window.location.reload()}
        >
          Try Again
        </Button>
      </Container>
    );
  }
  if (isReschedulingError) {
    return (
      <Container>
        <TitleSection
          imageSrc={SomethingWentWrongImage}
          title="Oops, that didn’t work."
          subtitle="Something went wrong while trying to reschedule. Please try again."
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowsClockwise />}
          onClick={() => window.location.reload()}
        >
          Try Again
        </Button>
      </Container>
    );
  }

  if (!isWithinRescheduleWindow) {
    return (
      <Container>
        <TitleSection
          imageSrc={RescheduleWindowClosedImage}
          title="Rescheduling window has closed."
          subtitle="For appointments within 24 hours, please text your BCBA and they'll help you reschedule."
        />
        <GoHomePrimary />
      </Container>
    );
  }

  if (!hasAvailableAppointments) {
    return (
      <Container>
        <TitleSection
          imageSrc={NoAppointmentsImage}
          title="No appointment times available."
          subtitle="We don’t have appointment times available at the moment. Text your BCBA and they’ll help you reschedule."
        />
        <GoHomePrimary />
      </Container>
    );
  }

  if (currentStep === STEPS.recommendations) return <Recommendations />;
  if (currentStep === STEPS.customDate) return <CustomDate />;
  if (currentStep === STEPS.review) return <RescheduleReview />;
  if (currentStep === STEPS.cancellationReview) return <CancelAppointment />;
  if (currentStep === STEPS.rescheduleConfirmation) {
    return (
      <Container>
        <TitleSection
          imageSrc={RescheduleCompleteImage}
          title="Your appointment has been rescheduled."
          subtitle="Your appointment has been rescheduled. See you soon!"
        />
        <EventSummary highlightText="New Appointment Time" />
        <GoHomePrimary />
      </Container>
    );
  }
  if (currentStep === STEPS.cancellationConfirmation) {
    return (
      <Container>
        <TitleSection
          title="Your appointment has be canceled."
          subtitle="Your appointment has been successfully canceled. We understand that plans can change, and we appreciate you letting us know in advance."
        />
        <GoHomePrimary />
      </Container>
    );
  }
  return <MakeupDay />;
}
